import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ResetSection() {
  const tableData = [{
    sit: 'El ardor mejoró pero sigo hinchada',
    sin: 'Sin protocolo de deshinchazón',
    con: 'Semana baja en fermentación + repoblación del microbioma'
  }, {
    sit: 'Articulaciones que duelen sin causa',
    sin: 'Sin reposición de colágeno',
    con: 'Colágeno tipo II + MSM + caldo articular'
  }, {
    sit: 'Cansancio que no se va aunque dormí',
    sin: 'Sin protocolo mitocondrial',
    con: 'B12 + Magnesio + ayuno 12:12'
  }, {
    sit: 'Piel opaca y pelo que cae más',
    sin: 'Sin eje intestino-piel',
    con: 'Zinc + Omega-3 + colágeno hidrolizado'
  }, {
    sit: 'Barriga que no baja aunque como bien',
    sin: 'Sin protocolo de microbioma',
    con: '3 fases de deshinchazón + probióticos específicos'
  }];
  return <section className="py-24 bg-brand-black border-t border-brand-gold/20" data-id="element-245">
      <div className="container mx-auto px-4" data-id="element-246">
        <div className="max-w-5xl mx-auto" data-id="element-247">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-248">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-gold mb-4 font-[Poppins,_sans-serif]" data-id="element-249">
              🌱 ¿QUÉ AGREGA EL RESET ANTI-INFLAMATORIO 21 DÍAS?
            </h2>
          </motion.div>

          {/* Desktop table */}
          <div className="hidden md:block overflow-x-auto mb-16 rounded-xl border border-gray-800" data-id="element-250">
            <table className="w-full text-left border-collapse" data-id="element-251">
              <thead data-id="element-252">
                <tr className="bg-brand-dark" data-id="element-253">
                  <th className="p-4 border-b border-gray-800 font-bold text-white w-1/3" data-id="element-254">
                    Situación
                  </th>
                  <th className="p-4 border-b border-gray-800 font-bold text-red-400 w-1/3" data-id="element-255">
                    <div className="flex items-center gap-2" data-id="element-256">
                      <X className="w-4 h-4" data-id="element-257" /> Sin Reset
                    </div>
                  </th>
                  <th className="p-4 border-b border-gray-800 font-bold text-brand-light w-1/3" data-id="element-258">
                    <div className="flex items-center gap-2" data-id="element-259">
                      <Check className="w-4 h-4" data-id="element-260" /> Con Reset
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-800" data-id="element-261">
                {tableData.map((row, i) => <tr key={i} className="hover:bg-brand-dark/50 transition-colors" data-id="element-262">
                    <td className="p-4 text-gray-300" data-id="element-263">{row.sit}</td>
                    <td className="p-4 text-gray-500" data-id="element-264">{row.sin}</td>
                    <td className="p-4 text-brand-light font-medium" data-id="element-265">
                      {row.con}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          {/* Mobile stacked cards */}
          <div className="md:hidden mb-16 rounded-2xl border border-gray-800 overflow-hidden" data-id="element-266">
            {/* Header */}
            <div className="bg-brand-dark p-5 flex flex-col items-center gap-3" data-id="element-267">
              <div className="flex items-center gap-2 text-red-400 font-bold text-base" data-id="element-268">
                ❌ Sin Reset
              </div>
              <div className="flex items-center gap-2 text-brand-light font-bold text-base" data-id="element-269">
                ✅ Con Reset
              </div>
            </div>

            {/* Rows */}
            {tableData.map((row, i) => <div key={i} className="border-t border-gray-800" data-id="element-270">
                {/* Situación */}
                <div className="px-5 py-4 bg-brand-black" data-id="element-271">
                  <p className="text-xs font-bold text-gray-400 mb-1" data-id="element-272">
                    Situación:
                  </p>
                  <p className="text-sm text-gray-200" data-id="element-273">{row.sit}</p>
                </div>
                {/* Sin Reset */}
                <div className="px-5 py-4 bg-brand-dark/80" data-id="element-274">
                  <p className="text-xs font-bold text-red-400 mb-1 flex items-center gap-1.5" data-id="element-275">
                    ❌ Sin Reset:
                  </p>
                  <p className="text-sm text-gray-400" data-id="element-276">{row.sin}</p>
                </div>
                {/* Con Reset */}
                <div className="px-5 py-4 bg-brand-green/5" data-id="element-277">
                  <p className="text-xs font-bold text-brand-light mb-1 flex items-center gap-1.5" data-id="element-278">
                    ✅ Con Reset:
                  </p>
                  <p className="text-sm text-gray-200" data-id="element-279">{row.con}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}